import { Location } from 'history';
import { ApplicationRoutingState } from '../types/application.types';

export const pushPreviousRoutedPathname = (pathName: string, location: Location) => {
    if (!location.state) {
        location.state = {} as ApplicationRoutingState;
    }
    const curState = location.state as ApplicationRoutingState;
    if (!curState.previousRoutedPathname) {
        curState.previousRoutedPathname = [];
    }
    curState.previousRoutedPathname.push(pathName);
};

export const popPreviousRoutedPathname = (location: Location) => {
    const curState = location?.state as ApplicationRoutingState;
    return curState?.previousRoutedPathname?.pop();
};
